import React from 'react';
import LazyLoad from 'react-lazyload';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import classnames from 'classnames';
import './FeaturedSection.css';

import { observer } from 'mobx-react';

import { buildAnchorCheckoutLink, buildAnchorLink } from '../../utils/helpers';
import { UserContext } from '../../context';
import AnchorStore from '../../store/AnchorStore';

import FeaturedMediaComponent from './FeaturedMediaComponent';

@observer
class FeaturedItem extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
    this.dayjs = dayjs;
    this.dayjs.extend(utc);
    this.dayjs.extend(localizedFormat);
  }

  getUrlForItem = () => {
    const { type, featuredItem } = this.props;
    const { user } = this.context;
    const { anchors } = AnchorStore;
    if (user?.account?.activeSubscription && type === 'featured') {
      return featuredItem?.url;
    }

    if (type === 'clipstore') {
      let featuredItemAnchor = anchors?.currentAnchors?.find(
        (anchor) => anchor.id === featuredItem.anchorId
      );
      if (!featuredItemAnchor) {
        featuredItemAnchor = anchors?.guestAnchors?.find(
          (anchor) => anchor.id === featuredItem.anchorId
        );
      }

      return buildAnchorCheckoutLink(
        featuredItem.anchorId,
        buildAnchorLink({
          id: featuredItem?.anchorId,
          name: featuredItemAnchor?.name,
        })
      );
    }

    if (
      type === 'past_clips' &&
      featuredItem?.programSegments?.find(
        (program) => program?.clip?.clipUrls !== null
      )
    ) {
      return '#';
    }

    return featuredItem?.url;
  };

  formatTitle = (title) => {
    if (this.props.type === 'past_clips') {
      const utcDate = this.dayjs(title).utc();

      return utcDate.format('dddd, LL');
    }

    return title;
  };

  onHandleClick = () => {
    const { type, featuredItem } = this.props;
    if (
      type === 'past_clips' &&
      featuredItem?.programSegments?.find(
        (program) => program?.clip?.clipUrls !== null
      )
    ) {
      this.props.setSelectedVideo(featuredItem);
    }
  };

  render() {
    const { featuredItem, type, hideTitle, loggedInUser, styles = {} } = this.props;
    const title = featuredItem.name || featuredItem.title;
    const URL = this.getUrlForItem();

    return (
      <div className={classnames('content-item-container', styles.contentItem)}>
        <a
          className='content-item'
          href={URL}
          title={title}
          onClick={this.onHandleClick}
        >
          <LazyLoad offset={10}>
            <div className='content-featured-clip'>
              <FeaturedMediaComponent
                featuredItem={featuredItem}
                loggedInUser={loggedInUser}
                type={type}
              />
            </div>
          </LazyLoad>
          {!hideTitle && (
            <div
              className={classnames(
                'content-item-caption',
                styles.contentItemCaption
              )}
            >
              <div
                className={classnames(
                  'content-item-title',
                  styles.contentItemTitle
                )}
              >
                {this.formatTitle(title)}
              </div>
            </div>
          )}
        </a>
      </div>
    );
  }
}

export default FeaturedItem;

FeaturedItem.defaultProps = { hideTitle: false, styles: {} };
